// H5 content module routes.
import type { RouteRecordRaw } from "vue-router";

export const contentRoutes: RouteRecordRaw[] = [
  {
    // The site root. Without this the app matched nothing at "/" and rendered a
    // blank page, because the router has no default route and the shell renders
    // only <RouterView>. Home is the landing page for an anonymous visitor.
    // The site root opens the sign-in page: the deployment is a members site
    // whose landing experience is authentication, and the design treats Home as
    // the page after signing in. A signed-in visitor who lands here is not stuck
    // on the form — the sign-in page forwards an established session onward.
    path: "/",
    name: "site-root",
    redirect: "/login",
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/modules/content/pages/HomePage.vue"),
  },
  {
    path: "/discover",
    name: "discover",
    component: () => import("@/modules/content/pages/DiscoverPage.vue"),
  },
  {
    path: "/profiles/:profileId",
    name: "profile-detail",
    component: () => import("@/modules/content/pages/ProfilePage.vue"),
  },
  {
    path: "/community",
    name: "community",
    component: () => import("@/modules/content/pages/CommunityPage.vue"),
  },
  {
    path: "/announcements/:noticeId",
    name: "notice-detail",
    component: () => import("@/modules/content/pages/AnnouncementPage.vue"),
  },
];
